export default __webpack_public_path__ + "static/media/AWS_Cloud_Prac.2fa1fd9b.png";